export const AlertSection = () => {
  return (
    <div className="w-full p-2 bg-rose-300 text-rose-700 text-center text-xs">
        Disarankan menggunakan browser Google Chrome terbaru!
    </div>
  )
}